// Class for managing the autodesk viewer instance for BIMSearch
// Connects to the BIMSearch engine and make any changes in Autodesk viewer in the BIMSearch applicaion

import { ToolbarExtension } from "./BimsearchToolbarExtension";
import {
    logError,
    logClusterButton,
    logDoubleClick,
    logRightClick,
} from "./IAmecLog";
import {
    updateCategory,
    updateFilterBy,
    applySecondFilter,
} from "./IScheduleLogic";
import { MenusSelection, DataForMenus } from "./ResultClasses";
import { postToServer, getFromServer } from "./CommonFunctions";
import { modelIdToKey } from "./TemplatesAndCollections";


// .viewer - autodek viewer
export class BimsearchViewer {
    // public:
    constructor(itemStruct, divElement, bimSearch, returnMethod, modelVersion) {
        
        this.version = modelVersion;
        this.bimSearch = bimSearch;
        this.returnMethod = returnMethod;
        //this.doubleClickReturnMethod = doubleClickReturnMethod;
        this.onSelectionChangeQuickStats = null;
        this.onSelectionChangeCustomParameters = null;
        this.customParametersButton = null;
        this.customParametersMethods = null;
        this.trackSelection = null;
        this.clearCustomParametersValuesFromRedux = null
        this.modelName = "";
        this.viewer = null;
        this.urn = itemStruct.idToOpen;
        this.divElement = divElement;
        this.collections = null;
        this.alertGiven = false;
        this.changingSelection = false;
        this.selectionHistory = [[]];
        this.selectionFuture = [];
        // add if null assign item id
        if (itemStruct.idForCollections == null) {
            this.idForCollections = itemStruct.id;
        }
        else { this.idForCollections = itemStruct.idForCollections; }

        this.bimSearch.loadCustomParameter(this.idForCollections);

        var options = {
            env: "AutodeskProduction",
            getAccessToken: this.getForgeToken,
            api:
                "derivativeV2" +
                (atob(this.urn.replace("_", "/")).indexOf("emea") > -1 ? "_EU" : ""), // handle BIM 360 US and EU regions
        };
        bimSearchViewerInstance = this;
        window.Autodesk.Viewing.Initializer(options, () => {
            bimSearchViewerInstance.intialize();
        });
    }

    intialize() {
        this.viewer = new window.Autodesk.Viewing.GuiViewer3D(this.divElement, {
            env: 'AutodeskProduction2',
            extensions: [
                //
                "ToolbarExtension",
                "Autodesk.DocumentBrowser",
                "Autodesk.VisualClusters",
                "Autodesk.AEC.Minimap3DExtension",
            ],
            profileSettings: {
                settings: {
                    viewCubeCompass: true,
                    reverseMouseZoomDir: true,
                    edgeRendering: true,
                    envMapBackground: true,
                    lightPreset: "Boardwalk",
                    selectionSetPivot: true,
                },
            },
        });


        this.viewer.start();
        //this.viewer.addEventListener(
        //    window.Autodesk.Viewing.EXTENSION_LOADED_EVENT, () => { bimSearchViewerInstance.removeButtons(); });

        this.viewer.setSelectionColor(
            new window.THREE.Color(0xfa8700),
            window.Autodesk.Viewing.SelectionType.MIXED
        ); // orange color for selection

        var documentId = "urn:" + this.urn;
        this.viewer.addEventListener(
            window.Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
            () => {
                bimSearchViewerInstance.modelLoaded();
            }
        );

        this.viewer.addEventListener(
            window.Autodesk.Viewing.EXTENSION_UNLOADED_EVENT,
            (id) => {
                bimSearchViewerInstance.closeVisualClusters(id);
            }
        );
        this.viewer.addEventListener(
            window.Autodesk.Viewing.SELECTION_CHANGED_EVENT,
            (selection) => {
                bimSearchViewerInstance.handleSelectionChange(selection);
            }
        );
        this.viewer.registerContextMenuCallback("AmecRc", (menu, status) => {
            bimSearchViewerInstance.rightClick(menu, status);
        });
        this.viewer.clickHandler.handleDoubleClick = (selection) => {
            bimSearchViewerInstance.onDoubleClick(selection);
        };

        document.addEventListener('keydown', (e) => {
            if (e.code == 'KeyZ' && e.ctrlKey) {
                // Add your code here
                bimSearchViewerInstance.undo();
            }
            if (e.code == 'KeyY' && e.ctrlKey) {
                // Add your code here
                bimSearchViewerInstance.redo();
            }
        });
        
        window.Autodesk.Viewing.Document.load(
            documentId,
            (doc) => {
                bimSearchViewerInstance.onDocumentLoadSuccess(doc);
            },
            (errorCode) => {
                bimSearchViewerInstance.onDocumentLoadFailure(errorCode);
            }
        );
        
    }

    async clearMemomry() {
        this.viewer.finish();
    }

    async isolateElements(elements, showNothing = false) {
        if (this.viewer == null) return;
        if (elements == null) elements = [];
        this.viewer.clearSelection();
        this.viewer.isolate(elements);
        this.viewer.fitToView(elements);

        if (showNothing && elements.length == 0) {
            this.viewer.hideAll();
        }
    }

    async selectElements(elements) {
        if (this.viewer == null) return;
        if (elements == null) elements = [];
        this.viewer.isolate(elements);
        this.viewer.fitToView(elements);
        this.viewer.select(elements);
    }

    async getCollections() {
        try {
            if (this.collections == null) {
                await navigator.locks.request('my_resource', async (lock) => {
                    if (this.collections == null) {
                        var url = `/api/forge/userdata/collections?model=${this.idForCollections}`;
                        this.collections = await getFromServer(url);
                    }
                });
            }
        }
        catch (err) {
            logError("FrontEnd.src.utils.builder.BimsearchViewer.getCollections", err.toString() + ", idForCollections = " + this.idForCollections);
        }

        if (this.collections == null)
            throw "Can't get model collections";

        return this.collections;
    }

    async saveCollection(collection, title, folder, descreption, color) {
        var index = await this.findCollectionIndex(title, folder);
        if (index >= 0)
            throw "selection set already exist";

        collection.title = title;
        collection.descreption = descreption;
        collection.color = color;

        var collections = await this.getCollections();
        if (collections.collectionsByFolder[folder] == null)
            collections.collectionsByFolder[folder] = [];
        collections.collectionsByFolder[folder].push(collection);
        collections.collectionsByFolder[folder].sort((a, b) => a.creationTime - b.creationTime);
        console.log(collections);
        
        await this.saveColletions(collections);
    }

    async addToCollection(elements, title, folder) {
        var index = await this.findCollectionIndex(title, folder);
        if (index < 0)
            throw "selection set doesn't exist";

        var collections = await this.getCollections();

        await this.bimSearch.addElementsToCollection(collections.collectionsByFolder[folder][index], elements);

        await this.saveColletions(collections);

        return collections.collectionsByFolder[folder][index];
    }

    async removeFromCollection(elements, title, folder) {
        var index = await this.findCollectionIndex(title, folder);
        if (index < 0)
            throw "selection set doesn't exist";

        var collections = await this.getCollections();

        await this.bimSearch.removeElementsFromCollection(collections.collectionsByFolder[folder][index], elements);

        await this.saveColletions(collections);

        return collections.collectionsByFolder[folder][index];
    }

    async deleteCollection(title, folder) {
        var collections = await this.getCollections();
        var index = await this.findCollectionIndex(title, folder);
        if (index >= 0) {
            collections.collectionsByFolder[folder].splice(index, 1);
            await this.saveColletions(collections);
        } else
            throw "can't find selection set";
    }   

    async editCollection(oldTitle, oldFolder, newTitle, newFolder, newDescreption, newColor) {

        var collections = await this.getCollections();
        var index = await this.findCollectionIndex(oldTitle, oldFolder);
        if (index < 0)
            throw "can't find selection set";
        if (oldTitle != newTitle || oldFolder != newFolder) {
            var index2 = await this.findCollectionIndex(newTitle, newFolder);
            if (index2 >= 0)
                throw "selection set with new name already exist in the folder";
        }

        var col = collections.collectionsByFolder[oldFolder][index];
        collections.collectionsByFolder[oldFolder].splice(index, 1);

        await this.saveCollection(col, newTitle, newFolder, newDescreption, newColor);
    }

    async addCollectionFolder(folderName) {
        var collections = await this.getCollections();
        if (collections.collectionsByFolder[folderName] == null) {
            collections.collectionsByFolder[folderName] = [];
            await this.saveColletions(collections);
        }
        else
            throw "folder already exist";
    }

    async deleteCollectionFolder(folderName) {
        if (folderName == defaultCollectionFolder)
            throw "can't delete default selection sets folder";

        var collections = await this.getCollections();
        if (collections.collectionsByFolder[folderName] == null)
            throw "folder doesn't exist";
        else {
            delete collections.collectionsByFolder[folderName];
            await this.saveColletions(collections);
        }
    }

    async renameCollectionFolder(originalName, newName) {
        if (originalName == defaultCollectionFolder)
            throw "can't rename default selection sets folder";

        var collections = await this.getCollections();
        if (collections.collectionsByFolder[newName] != null)
            throw ("Folder already exist");
        if (collections.collectionsByFolder[originalName] == null)
            throw ("Folder doesn't exist");

        collections.collectionsByFolder[newName] = collections.collectionsByFolder[originalName];
        delete collections.collectionsByFolder[originalName];
        await this.saveColletions(collections);
    }

    async saveColletions(collections) {
        this.collections = collections;
        this.saveCollectionsToDb();
    }


    async saveCollectionsToDb() {
        var url = `/api/forge/userdata/collections`;
        try {
            var res = await postToServer(url, this.collections);
            var success = await res.json();
            if (!success && !this.alertGiven) {
                this.alertGiven = true;
                window.alert("Oops! You have reaced the maximum memory for this model.\nYou can continue creating selection sets but they will not be saved.\nTo free some memory for this model, go to the selection set window and delete some of your unused selection sets.\nLet us know if you have any question or need some help");
            }
        }
        catch (err) {
            logError("FrontEnd.src.utils.builder.BimsearchViewer.saveColletions", err.toString());
        }
    }

    clearColors() {
        this.viewer.clearThemingColors();
    }

    colorElements(elements, color) {
        if (elements != null) {
            var tColor = new window.THREE.Color(color);
            var fColor = new window.THREE.Vector4(tColor.r, tColor.g, tColor.b, 1);
            elements.forEach(element => {
                this.viewer.setThemingColor(element, fColor);
            });
        }
    }

    colorCollections(collections) {
        if (!Array.isArray(collections))
            collections = [];

        this.viewer.clearThemingColors();
        var colorsArray = new Object();
        var elemntsToIsolate = [];

        collections.forEach(collection => {
            var color = new window.THREE.Color(collection.color);
            collection?.elements?.forEach(element => {
                var viewerId = this.bimSearch.propertiesManager.modelIdToViewerId[modelIdToKey(element.id)];
                if (viewerId != null) {
                    if (colorsArray[viewerId] == null) {
                        colorsArray[viewerId] = [];
                        elemntsToIsolate.push(viewerId);
                    }

                    colorsArray[viewerId].push(color);
                }
            });

        });

        elemntsToIsolate.forEach(element => {
            var colors = colorsArray[element].length;
            if (colors > 0) {
                var sumR = 0, sumG = 0, sumB = 0;
                colorsArray[element].forEach(color => {
                    sumR += color.r;
                    sumG += color.g;
                    sumB += color.b;
                });

                var colorVector = new window.THREE.Vector4(sumR/colors, sumG/colors, sumB/colors, 1);
                this.viewer.setThemingColor(element, colorVector);
            }
        });

        this.viewer.clearSelection();
        this.viewer.isolate(elemntsToIsolate);

    }
    
    registerRightClickMethods(saveAsCollection, copyToNewCollection, unassignSelection, setCustomParameters) {
        this.viewer.registerContextMenuCallback('collectionItems', async (menu, status) => {

            if (status.hasSelected) {
                menu.unshift({
                    title: 'Copy to new selection set',
                    target: copyToNewCollection
                });
                menu.unshift({
                    title: 'Save as selection set',
                    target: saveAsCollection
                });
                if (Object.keys(this.bimSearch.customParametersObject.parameters).length > 0) {
                    menu.unshift({
                        title: 'Set Custom Parameter',
                        target: setCustomParameters
                    });
                }
                menu.unshift({
                    title: ToolbarExtension.prototype.CustomParametersButtonRightClickMenuLabel,
                    target: ToolbarExtension.prototype.CustomParametersButton.onClick
                });
                
                this.menu = menu
            }
        });
    }

    unregisterRightClickMethods() {
        this.viewer.unregisterContextMenuCallback('collectionItems');
    }
    registerCustomParametersMethods (callbacksObject) {
        // pass react and redux handlers to extension
        ToolbarExtension.prototype.CustomParametersButtonOnClickMethods = callbacksObject
        // extract button from extension for close button click
        this.customParametersButton = ToolbarExtension.prototype.CustomParametersButton
    }

    registerTimebar(openMethod, closeMethod) {
        ToolbarExtension.prototype.TimebarOpenMethod = openMethod;
        ToolbarExtension.prototype.TimebarCloseMethod = closeMethod;
    }

    setTimebarButtonActive(isActive) {
        const btn = ToolbarExtension?.prototype?.TimebarButton;
        if (!btn) return;
        // Button.State = { ACTIVE: 0, INACTIVE: 1, DISABLED: 2 };
        btn.setState(isActive ? 0 : 1);
    }

    isolateSelection() {
        this.viewer.isolate(this.viewer.getSelection());
    }

    hideSelection() {
        this.viewer.hide(this.viewer.getSelection());
    }

    showAll() {
        this.viewer.showAll();
    }

    toggleGhosting(onOff) {
        this.viewer.setGhosting(onOff);
    }

    // private:

    //return the collection index in the folder, -1 if not found
    async findCollectionIndex(title, folder) {
        var collections = await this.getCollections();
        var index = -1;

        if (collections.collectionsByFolder[folder] != null) 
            index = collections.collectionsByFolder[folder].findIndex(element => element.title == title);

        return index;
    }

    onDocumentLoadSuccess(doc) {

        

        // if a viewableId was specified, load that view, otherwise the default view
        var viewables = doc.getRoot().getDefaultGeometry();

        // Try to find first 3d view and set it as active
        var viewItems = doc.getRoot().search({ role: "3d", type: "geometry" });
        if (viewItems.length > 0) {
            var firstViewItem = viewItems[0];
            if (
                firstViewItem.data !== undefined &&
                firstViewItem.data.guid !== undefined
            ) {
                viewables = doc.getRoot().findByGuid(firstViewItem.data.guid);
            }
        }

        this.viewer.loadDocumentNode(doc, viewables).then((i) => {
            this.toggleGhosting(true);
            var modelName = this.viewer.model
                .getData()
                .loadOptions.bubbleNode.getRootNode()
                .children[0].name();
            if (modelName.toLowerCase().endsWith("pdf")) {
                bimSearchViewerInstance.treeLoaded(null);
            }
        });

        
    }

    onDocumentLoadFailure(viewerErrorCode) {
        logError(
            "FrontEnd.utils.builder.BimsearchViewer.onDocumentLoadFailure",
            viewerErrorCode.toString()
        );
    }

    removeButtons() {
        if (this.viewer.toolbar == null) return;

        var navToolsConrol = this.viewer.toolbar.getControl("navTools");
        if (navToolsConrol)
            while (navToolsConrol._controls.length > 0)
                navToolsConrol.removeControl(navToolsConrol._controls[0]._id);

        var modelToolsControl = this.viewer.toolbar.getControl("modelTools");

        if (modelToolsControl) {
            modelToolsControl.removeControl("toolbar-explodeTool");
            modelToolsControl.removeControl("toolbar-sectionTool");
        }

        var settingsToolsConrol = this.viewer.toolbar.getControl("settingsTools");
        if (settingsToolsConrol)
            settingsToolsConrol.removeControl("toolbar-modelStructureTool");
    }

    // method to get credentials token
    getForgeToken(callback) {
        fetch("/api/forge/oauth/token").then((res) => {
            res.json().then((data) => {
                callback(data.access_token, data.expires_in);
            });
        });
    }

    closeVisualClusters(id) {
        if (this.viewer.loadedExtensions["Autodesk.VisualClusters"] === undefined) {
            return;
        }
        if (
            this.viewer.loadedExtensions["Autodesk.VisualClusters"].clusterButton
                ._state == 0
        )
            this.viewer.loadedExtensions[
                "Autodesk.VisualClusters"
            ].clusterButton.onClick();
    }

    async modelLoaded() {
        this.viewer.getObjectTree((tree) => {
            bimSearchViewerInstance.treeLoaded(tree);
        });
    }

    async treeLoaded(tree) {
        //set subtitile by model name and loaded version
        this.modelName = this.viewer.model
            .getData()
            .loadOptions.bubbleNode.getRootNode()
            .children[0].name();
        var modelHeader = this.modelName;
        if (this.version != null)
            modelHeader += " (" + this.version.split(":")[0] + ")";
        var res;
        if (tree != null) {
            res = await this.bimSearch.loadModel(this.viewer, tree, this.modelName);

            //Add log to cluster
            try {
                originalClusterMethod =
                    this.viewer.loadedExtensions["Autodesk.VisualClusters"].clusterButton
                        .onClick;
                this.viewer.loadedExtensions[
                    "Autodesk.VisualClusters"
                ].clusterButton.onClick = (data) => {
                    bimSearchViewerInstance.clusterClickMethod(data);
                };
            } catch (err) {
                logError(
                    "FrontEnd.src.utils.builder.BimsearchViewer.treeLoaded",
                    err.toString()
                );
            }
        }
        else {
            res = new DataForMenus();
            res.empty();
        }

        //Change Measure units
        if (
            this.viewer.loadedExtensions["Autodesk.Measure"] != null &&
            this.viewer.loadedExtensions["Autodesk.Measure"].sharedMeasureConfig !=
            null
        )
            this.viewer.loadedExtensions[
                "Autodesk.Measure"
            ].sharedMeasureConfig.units = "cm";

        this.viewer.loadExtension("NestedViewerExtension", { filter: ["2d", "3d"], crossSelection: true });
        
        this.returnMethod(res, modelHeader);
        
        this.customParametersButton = ToolbarExtension.prototype.CustomParametersButton;
    }

    clusterClickMethod(data) {
        originalClusterMethod(data);
        var onOff =
            this.viewer.loadedExtensions["Autodesk.VisualClusters"].clusterButton
                ._state == 0;
        logClusterButton(onOff);
    }

    async onDoubleClick(data) {
        var viewSelection = this.viewer.getSelection();
        if (viewSelection.length != 1) return;

        var props = this.bimSearch.propertiesManager.GetProperties(
            viewSelection[0]
        );
        if (props == null) return;

        var categoryProp = props.properties.find(
            (prop) =>
                prop.displayName == "Category" || prop.attributeName == "Category"
        );
        if (categoryProp == null) return;

        var category = categoryProp.displayValue;

        if (category == "Revit Category") return;

        var typeProp = props.properties.find(
            (prop) =>
                prop.displayName == typeParameter || prop.attributeName == typeParameter
        );
        if (typeProp == null) return;

        var type = typeProp.displayValue;

        var selection = [];
        for (var i = 0; i < this.bimSearch.allElements.length; i++) {
            var cProps = this.bimSearch.propertiesManager.GetProperties(
                this.bimSearch.allElements[i]
            );
            var cCategoryProp = cProps.properties.find(
                (prop) =>
                    prop.displayName == "Category" || prop.attributeName == "Category"
            );
            var cTypeProp = cProps.properties.find(
                (prop) =>
                    prop.displayName == typeParameter ||
                    prop.attributeName == typeParameter
            );

            if (
                cCategoryProp != null &&
                cCategoryProp.displayValue == category &&
                cTypeProp != null &&
                cTypeProp.displayValue == type
            )
                selection.push(this.bimSearch.allElements[i]);
        }

        this.selectElements(selection);

        logDoubleClick(category, type);
    }

    getFullSelectionData() {
        return this.bimSearch.getDataByCategory(this.viewer?.getSelection());
    }

    async rightClick(menu, status) {
        logRightClick(status.numSelected);
    }

    handleSelectionChange(selection) {
        
        if (this.changingSelection == false) {
            this.selectionHistory.push(selection.dbIdArray);
            this.selectionFuture = [];
            if (this.selectionHistory.length > selectionHistorySize)
                this.selectionHistory.shift();
        }

        if (this.onSelectionChangeQuickStats != null) {
            if (selection == null || selection.dbIdArray == null)
                selection.dbIdArray = [];
            var res = this.bimSearch.getCounterData(selection.dbIdArray);
            this.onSelectionChangeQuickStats(res);
        }

        // get custom properties/parameters for 1 element only. clear existing otherwise.
        if (this.onSelectionChangeCustomParameters) {
            const selectedElementCount = selection.dbIdArray.length
            if (selectedElementCount > 0) {
                this.onSelectionChangeCustomParameters()

            } else {

                this.clearCustomParametersValuesFromRedux()
            }
        }
        if (this.trackSelection){
            this.trackSelection(selection)
        }
    }

    async undo() {
        if (this.selectionHistory.length >= 2) {
            this.changingSelection = true;
            var currentSelection = this.selectionHistory.pop();
            this.selectionFuture.push(currentSelection);
            this.viewer.select(this.selectionHistory[this.selectionHistory.length - 1]);
            this.changingSelection = false;
        }
    }
    
    async redo() {
        if (this.selectionFuture.length >= 1) {
            this.changingSelection = true;
            var selection = this.selectionFuture.pop();
            this.viewer.select(selection);
            this.selectionHistory.push(selection);
            this.changingSelection = false;

        }
    }
}


var bimSearchViewerInstance;

const categoryPre = "Revit ";
const typeParameter = "Type Name";
const defaultCollectionFolder = "My selection sets";
const selectionHistorySize = 10;

var originalClusterMethod;
